import { ProfileCard, MyAdsList, PasswordChangeForm, EmailBindingForm, LineLinkingSection, NotificationPreferences } from './shared';
import MemberAnalyticsSection from './analytics/MemberAnalyticsSection';
import { useState } from 'react';
import './MemberDashboard.css';

export type DashboardTab = 'overview' | 'analytics' | 'settings';

export interface MemberDashboardProps {
  activeTab?: DashboardTab;
  // onTabChange is reserved for future interactive tab switching within the component
  // Currently, tab switching is controlled by URL navigation in MemberDashboardPage
  onTabChange?: (tab: DashboardTab) => void;
}

const MemberDashboard = ({
  activeTab: controlledActiveTab = 'overview',
}: MemberDashboardProps) => {
  // Fully controlled component - tab switching is handled by URL navigation in MemberDashboardPage
  const activeTab = controlledActiveTab;

  // Collapsible Password Change Section
  const PasswordChangeSection = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
      <div className="member-dashboard__collapsible">
        <button
          className="member-dashboard__collapsible-header"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
        >
          <span className="member-dashboard__collapsible-title">密碼變更</span>
          <span className={`member-dashboard__collapsible-icon ${isExpanded ? 'member-dashboard__collapsible-icon--expanded' : ''}`}>
            ▼
          </span>
        </button>
        {isExpanded && <PasswordChangeForm />}
      </div>
    );
  };

  return (
    <div className="member-dashboard">
      {/* Tab Content */}
      <div className="member-dashboard__content">
        {activeTab === 'overview' ? (
          <div className="member-dashboard__grid">
            {/* Profile Section */}
            <div className="member-dashboard__profile">
              <ProfileCard />
            </div>

            {/* Ads Section */}
            <div className="member-dashboard__ads">
              <MyAdsList />
            </div>
          </div>
        ) : activeTab === 'analytics' ? (
          <MemberAnalyticsSection />
        ) : (
          // Settings tab
          <div className="member-dashboard__settings">
            <NotificationPreferences />
            <EmailBindingForm />
            <LineLinkingSection />
            <PasswordChangeSection />
          </div>
        )}
      </div>
    </div>
  );
};

export default MemberDashboard;
